import { Box, FormControl, MenuItem, Select, Stack, Typography, useTheme } from "@mui/material";
import { delftBlue } from "@/theme/colors";
import CalendarIcon from "@/assets/Icon.svg";
import DownArrowIcon from "@/assets/mingcute_down-line.svg";
import { useSelector } from "react-redux";
import { selectUser } from "@/app/features/auth/authSlice";

const PeriodSelector = ({ period, onPeriodChange }) => {
  const theme = useTheme();
  const user = useSelector(selectUser);
  
  // Get username - prefer fullName, fallback to username, then email, then "User"
  const username = user?.fullName || user?.username || user?.email?.split("@")[0] || "User";

  return (
    <Box
      sx={{
        width: { xs: "100%", sm: 331.6 },
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: { xs: 0.5, sm: 0.75, md: 1 },
      }}
    >
      <Typography
        sx={{
          color: delftBlue[500],
          fontSize: { xs: 22, sm: 24, md: 28 },
          fontFamily: "Audiowide, sans-serif",
          fontWeight: 400,
          lineHeight: 1.29,
          width: "100%",
        }}
      >
        Hello! {username}
      </Typography>

      <Typography
        sx={{
          color: delftBlue[500],
          fontSize: { xs: 13, sm: 14, md: 16 },
          fontFamily: "Montserrat, sans-serif",
          fontWeight: 400,
          lineHeight: 1.5,
          width: "100%",
          wordWrap: "break-word",
          overflowWrap: "break-word",
        }}
      >
        Global overview and company management
      </Typography>
    </Box>
  );
};

export const PeriodDropdown = ({ period, onPeriodChange }) => {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      sx={{
        width: { xs: "100%", sm: 272.84 },
        minHeight: { xs: "auto", sm: 36 },
        alignSelf: { xs: "stretch", sm: "auto" },
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <Box
          component="img"
          src={CalendarIcon}
          alt="Calendar"
          sx={{
            width: 20,
            height: 20,
            objectFit: "contain",
          }}
        />
        <Typography
          sx={{
            color: delftBlue[500],
            fontSize: { xs: 12, sm: 13 },
            fontFamily: "Montserrat, sans-serif",
            fontWeight: 500,
            lineHeight: 1.85,
          }}
        >
          Period
        </Typography>
      </Stack>

      <FormControl
        sx={{
          flex: "1 1 0",
          alignSelf: "stretch",
        }}
      >
        <Select
          value={period}
          onChange={(e) => onPeriodChange(e.target.value)}
          sx={{
            paddingLeft: { xs: 1, sm: 1.5 },
            paddingRight: { xs: 1, sm: 1.5 },
            paddingTop: { xs: 0.75, sm: 1 },
            paddingBottom: { xs: 0.75, sm: 1 },
            background: "white",
            borderRadius: 2,
            outline: `1px ${theme.palette.neutral[100]} solid`,
            outlineOffset: "-1px",
            minHeight: { xs: 36, sm: "auto" },
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            "& .MuiSelect-select": {
              paddingRight: "32px !important",
              color: theme.palette.neutral[950],
              fontSize: { xs: 12, sm: 13 },
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 400,
              lineHeight: 1.85,
              display: "flex",
              alignItems: "center",
            },
          }}
          IconComponent={(props) => (
            <Box
              component="img"
              src={DownArrowIcon}
              alt="Dropdown"
              {...props}
              sx={{
                width: 24,
                height: 24,
                marginRight: 1,
                pointerEvents: "auto",
                cursor: "pointer",
              }}
            />
          )}
        >
          <MenuItem value="this-month">This Month</MenuItem>
          <MenuItem value="last-month">Last Month</MenuItem>
          <MenuItem value="this-quarter">This Quarter</MenuItem>
          <MenuItem value="last-quarter">Last Quarter</MenuItem>
          <MenuItem value="this-year">This Year</MenuItem>
          <MenuItem value="last-year">Last Year</MenuItem>
        </Select>
      </FormControl>
    </Stack>
  );
};

export default PeriodSelector;



